
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FormLabel extends Vue {
    @Prop() label?: string;
    @Prop({ default: false }) required!: boolean;
    @Prop() help?: string;
}
